import type { Board } from '../../types';

export const initialState = {
  boards: [] as Board[],
  currentBoard: null as Board | null,
  isLoading: false,
  isLoadingBoard: false,
  error: null as string | null,
};
